





















import BaseComponent from '@/components/base-component.vue';
import { getCurrentUserPermission, getLocalBusinessUnit, setSelectedBusinessUnitToLocal, updateUserPermissionsFromLocal } from '@/services/session-data';
import {
  getBusinessUnitsUser,
  setSelectedBusinessUnit
} from '@/services/users';
import * as changeBusinessUnit$ from '@/subjects/change-businessunit-dialog';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { IBusinessUnit } from '../../interfaces/business-units';

@Component
export default class UiChangeCurrentBusinessUnit extends BaseComponent {
  public businessUnitList: IBusinessUnit[] = [];

  @Prop(Boolean)
  public changeBusinessUnit: boolean;

  @Prop(Boolean)
  public showCancelBtn: boolean;

  @Prop()
  public empresa: any;

  @Watch('show')
  public onChangeShow(val): void {
    this.changeBusinessUnit = val;
  }

  @Watch('empresa')
  public onChangeEmpresa(val): void {
    this.onBusinessUnitClick(val);
  }

  public created(): void {
    this.getBusinessUnitsUser();
    changeBusinessUnit$.get().subscribe((payload) => {
      if (payload.status === changeBusinessUnit$.STATUS_SHOW) {
        this.openModalBusinessUnit();
      } else if (payload.status === changeBusinessUnit$.STATUS_HIDE) {
        this.closeModalBusinessUnit();
      } else if (payload.status === changeBusinessUnit$.STATUS_SELECT) {
        this.selectBusinessUnit(payload.id);
      }
    });
  }

  // Armazena os dados da BusinessUnit na sessão do usuário.
  public onBusinessUnitClick(businessUnit: any) {
    this.selectBusinessUnit(businessUnit.id);    
  }

  public selectBusinessUnit(id) {
    if (getLocalBusinessUnit() != null && getLocalBusinessUnit().id == id) {
      this.closeModalBusinessUnit();
      return;
    }
    this.loader.start();
    setSelectedBusinessUnit(id).subscribe(
      (data) => {
        this.closeModalBusinessUnit();
        let bu = this.businessUnitList.find(bu => bu.id == id)
        setSelectedBusinessUnitToLocal(bu);
        this.$emit('changeBusinessUnit', bu);
        getCurrentUserPermission().subscribe((permissions) => {
          updateUserPermissionsFromLocal(permissions).subscribe(res => {
            this.loader.stop();        
            window.location.reload();
          });
        });
      },
      () => {
        this.toast.show('Ocorreu um erro ao selecionar a empresa', 'error');
      },
    );
  }

  public closeModalBusinessUnit(): void {
    this.changeBusinessUnit = false;
    this.$emit('onCloseModal')
  }

  public openModalBusinessUnit() {
    this.changeBusinessUnit = true;
  }

  private getBusinessUnitsUser(): void {
    getBusinessUnitsUser().subscribe((data) => {
      this.businessUnitList = data;
    });
  }
}
